import { ONLINE_SALES, USER } from '../../services/apis';
import fetcher from '../../services/fetcher';

class OnlineSalesProvider {
    static async doGetProductsAvailability(payload) {
        const param = `?date=${payload?.date}&type=${payload.type}&brandCode=${payload.brandCode}&outletCode=${payload.outletCode}`;
        const request = `${ONLINE_SALES.API_CHECKOUT_PRODUCT_AVAILABILITY}${param}`;
        return fetcher.get(request);
    }

    static async doGetProductsDaysAvailability(payload) {
        const param = `?date=${payload?.date}&days=${payload?.days}&productId=${payload?.productId}&outletCode=${payload?.outletCode}`;
        const request = `${ONLINE_SALES.API_CHECKOUT_DAYS_AVAILABILITY}${param}`;
        return fetcher.get(request);
    }

    static async doPostCreatePaymentLink(payload, orderCategory, payloadParty) {
        const ENDPOINT_MAP = {
            PARTY: ONLINE_SALES.API_CREATE_PAYMENT_PARTY,
            SUBSCRIPTION: ONLINE_SALES.API_CREATE_PAYMENT_SUBSCRIPTION,
            TICKETING: ONLINE_SALES.API_CREATE_PAYMENT,
        };

        const endpoint = ENDPOINT_MAP[orderCategory] || ONLINE_SALES.API_CREATE_PAYMENT;

        return fetcher.post(endpoint, {
            ...(orderCategory === 'PARTY'
                ? {
                      ...payload,
                      forms: payloadParty,
                  }
                : payload),
        });
    }

    static async doGetBrands(payload) {
        const request = `${ONLINE_SALES.API_GET_BRANDS}?brandCode=${payload.brandCode}`;
        return fetcher.get(request);
    }

    static async doGetOutlets() {
        const request = ONLINE_SALES.API_GET_OUTLETS;
        return fetcher.get(request);
    }

    static async doGetHistoryTransaction() {
        const request = USER.API_USER_HISTORY_TRX;
        return fetcher.get(request);
    }

    static async doGetHistoryTransactionDetail(billNo, orderType) {
        const request = `${USER.API_USER_HISTORY_TRX_DETAIL}/${billNo}?orderType=${orderType}`;
        return fetcher.get(request);
    }

    static async doGetLoyaltyTier() {
        const request = USER.API_USER_LOYALTY_TIER;
        return fetcher.get(request);
    }

    static async doGetAvailableRewards() {
        const request = USER.API_USER_AVAILABLE_REWARDS;
        return fetcher.get(request);
    }

    static async doGetPointHistory() {
        const request = USER.API_USER_POINT_HISTORY;
        return fetcher.get(request);
    }

    static async doGetRedeemHistory() {
        const request = USER.API_USER_REDEEM_HISTORY;
        return fetcher.get(request);
    }

    static async doPostTriggerRedeem(payload) {
        const request = USER.API_USER_TRIGGER_REDEEM;
        return fetcher.post(request, payload);
    }
}

export default OnlineSalesProvider;
